import { ComponentProps } from 'react';

import LicenseFinder from './LicenseFinder';

const SampleLicenseNSW = '/images/components/LicenseFinder/sample_license_NSW.png';
const SampleLicenseVIC = '/images/components/LicenseFinder/sample_license_VIC.png';
const SampleLicenseQLD = '/images/components/LicenseFinder/sample_license_QLD.png';
const SampleLicenseACT = '/images/components/LicenseFinder/sample_license_ACT.png';
const SampleLicenseNT = '/images/components/LicenseFinder/sample_license_NT.png';
const SampleLicenseSA = '/images/components/LicenseFinder/sample_license_SA.png';
const SampleLicenseWA = '/images/components/LicenseFinder/sample_license_WA.png';
const SampleLicenseTAS = '/images/components/LicenseFinder/sample_license_TAS.png';

const tabs = ['NSW', 'VIC', 'QLD', 'ACT', 'NT', 'SA', 'WA', 'TAS'];

const licenseNumberAbovePhotoTitle = 'You can find the license number above your photo on the license.';

const tabsContent = [
  { id: 1, title: 'You can find your licence number underneath the address on your licence.', card: SampleLicenseNSW },
  { id: 2, title: licenseNumberAbovePhotoTitle, card: SampleLicenseVIC },
  { id: 3, title: licenseNumberAbovePhotoTitle, card: SampleLicenseQLD },
  { id: 4, title: 'You can find the license number below your date of birth on the license.', card: SampleLicenseACT },
  { id: 5, title: 'You can find the license number next to your photo on the license.', card: SampleLicenseNT },
  {
    id: 6,
    title: 'You can find the license number at the top left on the front of your license.',
    card: SampleLicenseSA,
  },
  { id: 7, title: licenseNumberAbovePhotoTitle, card: SampleLicenseWA },
  {
    id: 8,
    title: "You can find the license number under 'LIC NO' on the front of your license.",
    card: SampleLicenseTAS,
  },
];

export default {
  tabs,
  tabsContent,
  onClose: () => {},
  open: true,
  title: 'Where to find your licence number',
} as ComponentProps<typeof LicenseFinder>;
